import React from "react";

export default function Icon3({ fill = "#138201", stroke = "#61FF00" }) {
  return (
    <svg
      width={195}
      height={214}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#a)">
        <path
          d="M70.789 83.19c0 13.757 10.429 25.096 23.806 26.537v8.678H76.048c-10.788 0-19.548 8.759-19.548 19.547 0 10.789 8.76 19.548 19.547 19.548 8.968 0 16.53-6.049 18.83-14.286h5.2c2.3 8.236 9.861 14.286 18.829 14.286 10.788 0 19.547-8.759 19.547-19.548 0-10.788-8.759-19.547-19.547-19.547h-18.548v-8.678c13.378-1.439 23.811-12.778 23.811-26.537 0-14.73-11.96-26.69-26.69-26.69-14.731 0-26.69 11.96-26.69 26.69Zm34.47 56.735v-.001a2.882 2.882 0 0 0-2.852-2.472h-9.862a2.882 2.882 0 0 0-2.852 2.472v.001c-.956 6.676-6.708 11.813-13.646 11.813-7.608 0-13.786-6.178-13.786-13.786 0-7.607 6.178-13.785 13.786-13.785h42.858c7.608 0 13.786 6.178 13.786 13.785 0 7.608-6.178 13.786-13.786 13.786-6.938 0-12.69-5.137-13.646-11.813Zm13.646-11.997c-5.534 0-10.024 4.491-10.024 10.024 0 5.534 4.49 10.025 10.024 10.025 5.534 0 10.024-4.491 10.024-10.025 0-5.533-4.49-10.024-10.024-10.024Zm-45.74 7.143h-1.88a2.882 2.882 0 0 0 0 5.763h1.88v1.881a2.882 2.882 0 0 0 5.763 0v-1.881h1.882a2.882 2.882 0 0 0 0-5.763h-1.882v-1.881a2.882 2.882 0 0 0-5.762 0v1.881Zm45.74-1.381a4.264 4.264 0 0 1 4.262 4.262 4.264 4.264 0 0 1-4.262 4.261 4.264 4.264 0 0 1-4.262-4.261 4.264 4.264 0 0 1 4.262-4.262ZM97.476 62.26c11.551 0 20.929 9.38 20.929 20.93 0 11.55-9.378 20.928-20.929 20.928-11.55 0-20.928-9.378-20.928-20.929 0-11.55 9.378-20.928 20.928-20.928Zm1.483 4.175h-.001a2.867 2.867 0 0 0-2.964 0l-11.902 7.141c-.871.52-1.401 1.46-1.401 2.47v14.286c0 1.011.53 1.951 1.4 2.47l11.903 7.142c.911.55 2.053.551 2.964 0l11.903-7.141a2.875 2.875 0 0 0 1.401-2.47V76.045c0-1.01-.53-1.95-1.401-2.47l-11.903-7.141ZM88.451 77.677l9.024-5.414 9.025 5.414v11.024l-9.025 5.415-9.024-5.415V77.677Z"
          fill={fill}
          stroke={stroke}
        />
      </g>
      <defs>
        <filter
          id="a"
          x={0}
          y={0}
          width={194.953}
          height={214}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={28} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.492117 0 0 0 0 1 0 0 0 0 0.180833 0 0 0 0.6 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_433_15"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_433_15"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
